/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import mainBlue from '../../../../public/icons/ourTeam/new-main-blue.png'
import mainPink from '../../../../public/icons/ourTeam/new-main-pink.png'
import glow from '../../../../public/icons/ourTeam/glow.png'
import glowpink from '../../../../public/icons/ourTeam/glow-pink.png'

type HeroCardType = {
  title: string
  subtitle: string
  icon?: any
  content: string
  href?: string
  company?: {
    src: string
    width: number
    height: number
  }
  cardType: 'blue' | 'pink'
}

const backgroundImages = {
  blue: { main: mainBlue, glow },
  pink: { main: mainPink, glow: glowpink }
}

const OurTeamCard: React.FC<HeroCardType> = ({
  title,
  subtitle,
  icon,
  content,
  href,
  company,
  cardType
}) => {
  return (
    <section
      className={`relative flex flex-col items-center justify-between h-fit w-full ${
        cardType === 'pink' ? 'sm:h-[380px]' : 'sm:h-[400px] lg:h-[420px]'
      }`}
    >
      <Image
        src={backgroundImages[cardType].main}
        alt='background'
        className='w-full absolute top-0 h-full z-10 '
        width={backgroundImages[cardType].main.width}
        height={backgroundImages[cardType].main.height}

      />
      <Image
        src={backgroundImages[cardType].glow}
        alt='glow'
        className='absolute -top-16 md:-top-10 w-full z-10'
        width={305}
        height={290}
      />

      <section className='px-5 pt-6 flex flex-col gap-1 w-full z-10'>
        <div className='min-h-[7vh] flex flex-col items-center md:gap-1'>
          {icon && (
            <Image
              width={68}
              height={68}
              src={icon}
              alt='icon'
              className='w-[68px] h-[68px]'
            />
          )}
          <div className='flex flex-col items-center'>
            <p className='font-bold text-[15px] text-white leading-6 sm:leading-7'>
              {title}
            </p>
            <span
              className={`text-[15px] font-bold text-center ${
                cardType === 'pink' ? 'text-hero-pink-200' : 'text-hr-blue-100'
              }`}
            >
              {subtitle}
            </span>
          </div>
        </div>
        <p
          dangerouslySetInnerHTML={{ __html: content }}
          className='text-white text-center px-3 pb-3 sm:pb-0 text-[12px]'
        ></p>
      </section>

      <div className='flex justify-center items-center z-20 mx-auto gap-2 pb-4 px-7 md:w-full'>
        {href && (
          <Link className='cursor-pointer' href={href} target='_blank'>
            <Image
              width={27}
              height={27}
              src={
                cardType === 'pink'
                  ? '/icons/linkdin-team.svg'
                  : '/icons/linkedin-team-blue.svg'
              }
              alt='Linkedin icon'
              className='cursor-pointer'
            />
          </Link>
        )}
        {company && (
          <Image
            src={company.src}
            width={company.width}
            height={company.height}
            alt='company logo'
          />
        )}
      </div>
    </section>
  )
}

export default OurTeamCard
